import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/* Tag Reserve Words */
export function tagReserveWordsValidator(): ValidatorFn {

    const reserveWords: Set<string> = new Set(['--Unassigned Tag--']);
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        return reserveWords.has(control.value) ? { reserveWords: { title: `"${control.value}"` } } : null;
    };
}